import React, { useState, useEffect,useRef, useContext, Component } from 'react';
import { useNavigate,Link } from "react-router-dom";
import TestingHeader from './TestingHeader';
import TestingFooter from './TestingFooter';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; // lightweight version
import { motion, useInView, animate } from "framer-motion";
import spaceAudio from '../../assets/audio/space.mp3'; // ✅ Correct way to import audio
import scrollSound from '../../assets/audio/scroll.mp3'; // ✅ Correct way to import audio
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";

 const TestingHome = () => {


    const [hide, setHide] = useState(false);



  const bgAudioRef = useRef(null);
  const scrollAudioRef = useRef(null);
  const playedScroll = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    // ✅ Background Audio setup
    bg.loop = true;
    bg.volume = 0.2;
    bg.preload = "auto";
    bg.currentTime = 0.3;

    bg.play()
      .then(() => setIsPlaying(true))
      .catch(() => {
        console.log("Autoplay blocked — click once to start background audio.");
        const startBg = () => {
          bg.play().then(() => setIsPlaying(true)).catch(() => {});
          window.removeEventListener("click", startBg);
        };
        window.addEventListener("click", startBg);
      });

    // ✅ Scroll effect
    const playScrollFx = () => {
      if (playedScroll.current) return;
      playedScroll.current = true;
      scrollFx.currentTime = 0;
      scrollFx.volume = 0.2;
      scrollFx.play().catch(() => {});
      setTimeout(() => (playedScroll.current = false), 800);
    };

    window.addEventListener("scroll", playScrollFx);
    return () => window.removeEventListener("scroll", playScrollFx);
  }, []);

  // ✅ Toggle audio manually
  const handleToggleAudio = () => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    if (isPlaying) {
      bg.pause();
      scrollFx.pause();
      setIsPlaying(false);
    } else {
      bg.play().then(() => setIsPlaying(true)).catch(() => {});
      // Don’t auto-play scrollFx; it’s handled on scroll
    }
  };

    const [flipped, setFlipped] = useState(null);

    const services = [
  {
    id: 1,
    title: "Home Automation",
    img: "/assets/img/home-automation.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "Home automation allows you to control lights, appliances, and more with your smartphone or voice assistants."
  },
  {
    id: 2,
    title: "Security",
    img: "/assets/img/modern-lock.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "Our security systems include CCTV, access control, and motion sensors for full protection."
  },
  {
    id: 3,
    title: "AV Solution",
    img: "/assets/img/av-solution.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "AV solutions provide immersive sound and video experiences for home and office environments."
  }
];

 const [engineReady, setEngineReady] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine); // load the minimal engine
    }).then(() => {
      setEngineReady(true);
    });
  }, []);

 
  // 👇 OUTSIDE any component
const particlesOptions = {
  background: { color: { value: "white" } },
  fpsLimit: 60,
  interactivity: {
    events: {
      onHover: { enable: true, mode: "repulse" },
      onClick: { enable: true, mode: "push" },
    },
    modes: {
      repulse: { distance: 100, duration: 0.4 },
      push: { quantity: 3 },
    },
  },
  particles: {
    color: { value: "#f6ff00ff" },
    links: {
      // color: "#2d3058ff",
          color: "#ffffffff",
      distance: 120,
      enable: true,
      // opacity: 0.3,
      opacity: 1,
       width: 1,
    },
    move: {
      enable: true,
      speed: 1,
      outModes: { default: "bounce" },
    },
    number: { value: 150, density: { enable: true, area: 100 } },
    opacity: { value: 0.3 },
    shape: { type: "circle" },
    size: { value: { min: 1, max: 3 } },
  },
  detectRetina: true,
};


  function Counter({ to = 0, duration = 1.2, suffix = "", decimals = 0 }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -20% 0px" });
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => {
        const factor = Math.pow(10, decimals);
        setValue(Math.round(v * factor) / factor);
      },
    });
    return () => controls.stop();
  }, [inView, to, duration, decimals]);

  return (
    <span ref={ref}>
      {value.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}
      {suffix}
    </span>
  );
}


const testimonialDate =[
  {
    id: 1,
    name: "Rahul Sharma",
    message:
      "Working with Altima has been an incredibly smooth and rewarding experience. Their team understood our office security requirements perfectly and suggested solutions that were both practical and advanced. The installation process was handled professionally, with clear communication at every stage. What impressed me most was the way they explained each feature and ensured we were fully comfortable using the system. Ever since the upgrade, our staff feels safer and our overall monitoring is far more efficient. I would highly recommend Altima to anyone looking for reliable and intelligent security systems.",
  },

  {
    id: 2,
    name: "Neha Verma",
    message:
      "Altima has truly exceeded our expectations. Their perimeter security solution has made a huge difference to our residential property. From the very first consultation, the team was transparent, knowledgeable, and extremely patient in answering all our questions. The quality of their equipment is top-notch and the response time has been exceptional. We’ve already noticed a major improvement in safety and awareness around our premises. Their after-sales support is just as impressive—always available, polite, and very helpful. I am extremely satisfied and confidently recommend Altima to others.",
  },

  {
    id: 3,
    name: "Amit Gupta",
    message:
      "The level of professionalism and expertise that Altima brought to our home automation project was outstanding. They handled everything from planning to installation with great attention to detail. The automation system is seamless, intuitive, and has genuinely improved our everyday comfort. Whether it’s lighting, security, or AV integration, everything works perfectly in sync. What truly sets Altima apart is the way they prioritize customer convenience—they ensure everything is simple to use and customized to your lifestyle. It was one of the best investments we made for our home.",
  },

  {
    id: 4,
    name: "Priya Singh",
    message:
      "We hired Altima for a complete AV transformation of our conference room, and the outcome was beyond impressive. The sound clarity, display quality, and overall design have elevated the professional experience for our entire team. Their engineers are highly skilled and take the time to understand the exact requirements before recommending solutions. The project was completed on time, and the training provided afterward made everything very easy to operate. Even guests who visit our office frequently compliment the setup. Altima stands out for its exceptional quality, service, and long-term reliability.",
  }
];


 
  const blogData = [
  {
    id: 1,
    image: "/assets/img/home-automation.webp",
    date: "Jan 20, 2025",
    title: "How To Trust Your Intuition When You’re Making A Decision",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 2,
    image: "/assets/img/home-automation.webp",
    date: "Feb 15, 2025",
    title: "The Science of Happiness: 10 Ways to Boost Your Mood",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 3,
    image: "/assets/img/home-automation.webp",
    date: "Mar 5, 2025",
    title: "Mastering Time Management for Busy People",
    author: "Altima Global",
    link: "#"
  }
];


const PARTNER_BRANDS = [
  { id: 1, name: "Brand One", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 2, name: "Brand Two", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 3, name: "Brand Three", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 4, name: "Brand Four", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 5, name: "Brand Five", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 6, name: "Brand Six", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
];

const FAQ_DATA = [
  {
    id: 1,
    question: "What kind of solutions does Altima provide?",
    answer:
      "We provide end-to-end Security, AV and Home Automation solutions including perimeter security, CCTV surveillance, access control, fire systems, auditorium AV, commercial cinema and fully integrated smart home experiences."
  },
  {
    id: 2,
    question: "Do you handle both design and installation?",
    answer:
      "Yes. Our team handles complete solution design, product selection, wiring layouts, installation, configuration and final handover. We also train your staff or family members to operate the system with ease."
  },
  {
    id: 3,
    question: "Can the systems be integrated with existing infrastructure?",
    answer:
      "In most cases, yes. We assess your current infrastructure and suggest the best way to integrate new systems with existing cabling, devices and networks to avoid unnecessary replacement costs."
  },
  {
    id: 4,
    question: "Do you provide post-installation support and maintenance?",
    answer:
      "Absolutely. We offer AMC and on-call support options. Our engineers are available for health checks, firmware upgrades, troubleshooting and future enhancements as your needs evolve."
  },
  {
    id: 5,
    question: "Do you work on residential, commercial and institutional projects?",
    answer:
      "Yes. We work with luxury homes, offices, schools, colleges, hotels, hospitals, auditoriums and industrial facilities—designing custom solutions based on the use-case and budget."
  }
];


const AWARDS = [
  {
    id: 1,
    title: "ISO 9001:2015 Certified",
    image: "/assets/img/award.png",
  },
  {
    id: 2,
    title: "Best Automation Integrator Award 2023",
    image: "/assets/img/award.png",
  },
  {
    id: 3,
    title: "Authorized Partner Certification",
    image: "/assets/img/award.png",
  },
  {
    id: 4,
    title: "Industry Excellence Badge",
    image: "/assets/img/award.png",
  },
  
];

 
 const FEATURED_PRODUCTS = [
  {
    id: 1,
    title: "Video Surveillance Systems (CCTV)",
    category: "Security",
    image: "/assets/img/home-automation.webp",
    description:
      "Hanwha • Tyco American Dynamics • Panasonic • Honeywell • ANPR Cam • Remote Monitoring – Milestone & Genetec",
  },
  {
    id: 2,
    title: "Fire Safety & Alarm Systems",
    category: "Fire & Life Safety",
    image: "/assets/img/av-solution.webp",
    description:
      "Fire Alarm System • Honeywell Fire • Simplex by Johnson Control • Verbena • Bosch Fire Alarm • PA Systems • Linear Heat Sensing for Cables",
  },
  {
    id: 3,
    title: "Home Automation Solutions",
    category: "Smart Living",
    image: "/assets/img/home-automation.webp",
    description:
      "Smart Lighting • Scene-Based Controls • Motion Sensors • App & Voice Automation • Smart Thermostats • Curtain & Blinds Automation • Wireless Networking",
  },
  {
    id: 4,
    title: "Access Control & Attendance Systems",
    category: "Access Management",
    image: "/assets/img/av-solution.webp",
    description:
      "Biometric Systems • Face Access • Iris Access • Suprema • Idemia Morpho • Time Attendance Software • Integrated Access Solutions",
  },
];



    return (
        <>
      <audio ref={bgAudioRef} src={spaceAudio} preload="auto" />
    
      {/* 🔊 short scroll sound */}
      <audio ref={scrollAudioRef} src={scrollSound} preload="auto" />

            <TestingHeader />

<div className=' position-relative'>

{hide &&
<div className="hero-section py-4 position-relative overflow-hidden bg-white"  >
   {/* Particle Background */}
       
<div className="container py-4">
  <div className="row">
    <div className="col-md-6 z-1">

<div className="content-box section-headings">
  <motion.div className="subheading text-15 subheading-bg bg-white"  
   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0 }} >
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_414319)">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
   <span >
 welcome to ALTIMA 
  </span>
  
   
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_4143)z">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
  </motion.div>

  <motion.h2
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0.2 }}
     className="heading text-70 fw-600">  
 Transform your home. Experience smart living.</motion.h2>
  <motion.div className="text text-18"   
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}  >
    Transform your business with expert consultancy services our team of
    seasoned consultants unparalleled. Transform your business.
  </motion.div>

  


  <div className="buttons">
    <motion.div
       className="button button--secondary border"
      aria-label="hero button"
         initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      Free Consultation
      <span className="svg-wrapper">
        <svg
          className="icon-20"
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </motion.div>
  </div>
</div>

    </div>
    <div className="col-md-6 ms-auto">
      <motion.div   initial={{ opacity: 0, y: -50 , scale: 0.5}}
    whileInView={{ opacity: 1,y: 0 , scale: 1}}
    viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }} // add delay here
 className="mymodel-hero position-relative">

        <motion.div className='tvbox screen-box-container'   
         initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1,y: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay: 0.5 }} // add delay here
  >
          <div className="screen-box position-relative">
 
          <h4 className='z-1 position-relative fw-bold'> Smart TV <br/> 
       <svg
  fill="#000000"
  width="30px"
  height="30px"
  viewBox="0 0 32 32"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  className="mt-2"
>
  <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
</svg>


 </h4>
          </div>

     <img src="/assets/img/arrow.png" className="arrow" />

        </motion.div>

          <motion.div className='speakerbox right-side screen-box-container'   
         initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1,y: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay:0.8 }} // add delay here
  >
          <div className="screen-box position-relative">
 
          <h4 className='z-1 position-relative fw-bold'> Speaker <br/> 
       <svg
  fill="#000000"
  width="30px"
  height="30px"
  viewBox="0 0 32 32"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  className="mt-2"
>
  <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
</svg>


 </h4>
          </div>

     <img src="/assets/img/arrow.png" className="arrow" />

        </motion.div>


          <motion.div className='curtainbox right-side screen-box-container'   
         initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1,y: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay:1 }} // add delay here
  >
          <div className="screen-box position-relative">
 
          <h4 className='z-1 position-relative fw-bold'> Curtain <br/> 
       <svg
  fill="#000000"
  width="30px"
  height="30px"
  viewBox="0 0 32 32"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  className="mt-2"
>
  <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
</svg>


 </h4>
          </div>

     <img src="/assets/img/arrow.png" className="arrow" />

        </motion.div>
        
        <img src="/assets/img/tvscreen.gif" className="tv-screen shadow" />
          <img src="/assets/img/lamp.webp" className="lamp" />
           <img src="/assets/img/speaker.gif" className="speaker" />
           <img src="/assets/img/curtain.gif" className="curtain" />
         <img src="/assets/img/3dmodel.webp" alt='3dhouse' className='w-100 hdhouse-img'/>
      </motion.div>
    </div>
  </div>
</div>



<div className='remotebox' style={{zIndex:2}}>
<div className="dashboard">
  <header>
    <div className="f fe">
      <div className="icon icon-w" />
      <div className="heading">
        <h5 className="date">1 Feb 2019</h5>
        <h2 className="title">Cloudy</h2>
      </div>
    </div>
    <div className="weather f d-flex">
      <div>
        <strong>
          26°<sup>C</sup>
        </strong>
        <p>Indoor Temp.</p>
      </div>
      <div>
        <strong>48.2%</strong>
        <p>Outdoor Humidity</p>
      </div>
      <div>
        <strong>52.99</strong>
        <p>Indoor Temp.</p>
      </div>
    </div>
  </header>
  <section>
    {/* Category */}
    <div className="category">
      <ul>
        <li>
          <a href="#!" className="active">
            Living Room
          </a>
        </li>
        <li>
          <a href="#!">Kitchen</a>
        </li>
        <li>
          <a href="#!">Dinning</a>
        </li>
        <li>
          <a href="#!">Weather</a>
        </li>
      </ul>
    </div>
    {/* Appliances */}
    <div className="appliances">
      <div className="appliance">
        <input type="checkbox" name="a" id="a" />
        <label htmlFor="a">
          <i className="l" />
          <strong>Lamp</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="appliance">
        <input type="checkbox" name="a" id="b" />
        <label htmlFor="b">
          <i className="r" />
          <strong>Router</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="appliance">
        <input type="checkbox" name="a" id="c" />
        <label htmlFor="c">
          <i className="a" />
          <strong>Air</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="appliance">
        <input type="checkbox" name="a" id="d" />
        <label htmlFor="d">
          <i className="f" />
          <strong>Fridge</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="m-player">
         <div className="player">
          <div className="disc" />
          <div className="artist">
            <p>Background Audio</p>
            <small>Tool</small>
          </div>
          <div className="controls" onClick={handleToggleAudio}>
            <input type="checkbox" name="a" id="p"  checked={isPlaying} readOnly />
            <label htmlFor="p">
              <div className="control" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</div>


</div>
   }

{hide &&
<div className="hero-section py-4 position-relative overflow-hidden bg-white" style={{background:'#f7fdff'}}>

      {engineReady && (
          <Particles
            id="tsparticles"
            options={particlesOptions}
            className="position-absolute top-0 start-0 w-100 h-100"
          />
        )}

  <div className="position-relative py-4">
    <div className='container py-4'>
      <div className='row'>
        <div className="col-md-5">

<div className="content-box section-headings">
  <motion.div className="subheading text-15 text-white subheading-bg border-white"  
   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0 }} >
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_414319)">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
   <span >
 welcome to ALTIMA 
  </span>
  
   
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_4143)z">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
  </motion.div>

  <motion.h2
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0.2 }}
     className="heading text-60 fw-600 text-dark">  
 Transform your <span className='text-Gradient'> home Experience </span>  smart living.</motion.h2>
  <motion.div className="text text-18  text-dark"   
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.4 }}  >
    Transform your business with expert consultancy services our team of
    seasoned consultants unparalleled. Transform your business.
  </motion.div>
  <br/>
  <motion.div className="text text-18  text-white"   
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}  >

      <a href='#' className="hologram-btn dark">
  Learn More <i className="ri-arrow-right-up-line fs-4 fw-light"/>
 
</a>

 
  </motion.div>
</div>
        </div>

           <div className="col-md-7">
             <motion.div   
         initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1,x: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay:0.5 }}   className='3dmodel-box position-relative'>
              <div className="top-floor-bg"/>
              <div className='top-floor-box'> 
              <div className="ac-install"> 
               <img src="/assets/img/ac-on-new.webp" alt='3dhouse' className='w-100  ac-on d-none'/>   
                <img src="/assets/img/ac-off-new.webp" alt='3dhouse' className='w-100 ac-off d-block'/> 
                <div className="ac-box p-2 bg-white rounded ">
                  <div className="bg-secondary border-rounded text-white p-2 rounded d-block">
                    <h4 className='small'> OFF</h4>
                  </div>
                    <div className="bg-success border-rounded text-white p-2 rounded d-none">
                    <h4 className='small'>   23<sup>°</sup></h4>
                  </div>
                  <div className='p-2'>
                    <i className="ri-triangle-fill"/> <i className="ri-circle-fill"/>
                  </div>
                </div>
              </div>
             
               <div className="ac-border"  />

              <div className="fan-install"> 
               <img src="/assets/img/celling-fan.webp" alt='3dfan' className='w-100  celling-fan-off d-block'/>   
                <img src="/assets/img/celling-fan.gif" alt='3dfan' className='w-100 celling-fan-on d-none'/> 

                        <div className="fan-box p-2 bg-white rounded ">
                  <div className="bg-secondary border-rounded text-white p-2 rounded d-block">
                    <h4 className='small'> OFF</h4>
                  </div>
                    <div className="bg-success border-rounded text-white p-2 rounded d-none">
                    <h4 className='small'> ON</h4>
                  </div>
                  <div className='p-2'>
                    <i className="ri-triangle-fill"/> <i className="ri-circle-fill"/>
                  </div>
                </div>

              </div>

               <div className="fan-border"  />
                </div>
                <div className="ground-floor-bg"/>
                <div className="ground-floor-box">
                  
                  
                    <div className="tv-install"> 
               <img src="/assets/img/tvscreen.gif" alt='3dhouse' className='w-100  tv-on d-none'/>   
                <img src="/assets/img/tv-black.webp" alt='3dhouse' className='w-100 tv-off d-block'/> 
                <div className="ac-box custom-remode p-2 bg-white rounded ">
                  <div className="bg-secondary border-rounded text-white p-2 rounded d-block">
                    <h4 className='small'> OFF</h4>
                  </div>
                    <div className="bg-success border-rounded text-white p-2 rounded d-none">
                    <h4 className='small'>   23<sup>°</sup></h4>
                  </div>
                  <div className='p-2'>
                    <i className="ri-triangle-fill"/> <i className="ri-circle-fill"/>
                  </div>
                </div>
              </div>

                </div>

              <div className="ground-stairs-bg"/>


 <img src="/assets/img/3dhouse-new.webp" alt='3dhouse' className='w-100'/> 
  
              
            </motion.div>
        </div>

      </div>
    </div>
</div>
</div>
   }

<div className="hero-section py-0 position-relative overflow-hidden bg-white" >
     {engineReady && (
          <Particles
            id="tsparticles"
            options={particlesOptions}
            className="position-absolute top-0 start-0 w-100 h-100"
          />
        )}
  <img src="/assets/img/smart-bg.webp"  className='w-100'/>

</div>
   


<div className="container-fluid py-2 " style={{ backgroundColor: "#dbeff7",position:'sticky',top:0,zIndex:2 }}>
  <div className="container">
    <div className="row align-items-center">
      {/* Left: Product Image */}
      <div className="col-auto">
        <img
          src="https://cdn.optimizely.com/img/12265111463/86b9267aa83a432fa450d58f99414864.png"
          className="img-fluid"
          alt="Product"
          style={{width:80,height:50,objectFit:'cover',transform:'scale(1.2)'}}
        />
      </div>
      {/* Center: Text + Timer */}
      <div className="col d-flex justify-content-center align-items-center text-center">
        <span className="fw-semibold me-3">Hurry! Call Now</span>
        {/* Timer boxes */}
        <div className="d-flex align-items-center">
          <span className="bg-white rounded-3 px-3 py-1 fw-semibold me-1">
            00<small className="text-muted ms-1">d</small>
          </span>
          <span className="bg-white rounded-3 px-3 py-1 fw-semibold me-1">
            04<small className="text-muted ms-1">h</small>
          </span>
          <span className="bg-white rounded-3 px-3 py-1 fw-semibold me-1">
            08<small className="text-muted ms-1">m</small>
          </span>
          <span className="bg-white rounded-3 px-3 py-1 fw-semibold">
            38<small className="text-muted ms-1">s</small>
          </span>
        </div>
      </div>
      {/* Right: Phone + Close */}
      <div className="col-auto d-flex align-items-center">
        <a
          href="tel:8557430963"
          className="me-4 fw-semibold text-decoration-none text-dark"
        >
          <i className="ri-phone-fill"/> 9876543210
        </a>
        <button type="button" className="btn btn-link p-0  text-decoration-none text-dark fs-4">
          ×
        </button>
      </div>
    </div>
  </div>
</div>

   
<div className="multicolumn multicolumn-page bg-white">
  <div className=' mt-50 mb-50'>

 
  <div className="container">

    <div className="multicolumn-inner">
      <div className='myheading'>

 
      <motion.h2   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0 }}
     className=' mb-4 pb-4 '> Services <span className='text-Gradient'> We Offer</span></motion.h2>
          </div>

      <div  className="row product-grid mt-4 servicebx">
        
         {services.map((service) => (
          <motion.div
            key={service.id}
            className="col-xl-4 col-md-6 col-12"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5 }}
          >
            {/* FLIP CONTAINER */}
            <div
             onMouseEnter={() => setFlipped(service.id)}
             onMouseLeave={() => setFlipped(null)}
              style={{
                perspective: "1000px",
                position: "relative",
                width: "100%",
                height: "100%", // ensures card takes up grid height
                minHeight: "360px", // ✅ keeps height stable to prevent overlap
                cursor: "pointer"
              }}
              className=''
            >
              {/* INNER WRAPPER */}
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  transformStyle: "preserve-3d",
                  transition: "transform 0.6s ease-in-out",
                  transform:
                    flipped === service.id
                      ? "rotateY(180deg)"
                      : "rotateY(0deg)"
                }}
              >
                 
                {/* FRONT SIDE */}
                <div
                  className="multicolumn-card  bg-white p-0"
                 
                  aria-label="View Service Details"
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    transform: "rotateY(0deg)",
                    top: 0,
                    left: 0
                  }}
                >
                <img
                      
                      src={service.img} 
                      className="p-0 position-absolute"
                    />
<div className='position-absolute w-100 p-4 bottom-0' >
 <motion.div    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.5, delay: 0.3 }} className="d-flex rounded-pill w-100 justify-content-between shadow align-items-center px-2 py-2 bg-white" style={{width:'80%'}}>
                        <h4
                 
                    className="heading text-20 fw-medium ps-2"
                   >
                    {service.title}
                  </h4>
 <i className="ri-arrow-right-circle-fill text-20"></i>
                    </motion.div>
</div>
                   

                
                  

               
                </div>

                {/* BACK SIDE */}
                <div
                  className="multicolumn-card  border-gradient rounded bg-white"
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    padding: "20px",
                    backfaceVisibility: "hidden",
                    transform: "rotateY(180deg)",
                    top: 0,
                    left: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <h3 className="heading text-24 fw-bold mb-3">
                    {service.title}
                  </h3>
                  <p className="text text-16 text-center mb-3">
                    {service.more}
                  </p>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setFlipped(null);
                    }}
                   className="mt-3 subheading text-decoration-none text-15 text-white
                    subheading-bg bg-dark"

                  >
                   View Now <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        ))}

      </div>
    </div>

  </div>

   </div>
 

 <div className="container my-5">
  <div className="position-relative overflow-hidden rounded-4">
    {/* Background video */}
    <div className="ratio ratio-21x9">
      <video
        className="w-100 h-100 object-fit-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source
          src="https://www.vivint.com/sites/default/files/video-thumbnails/2022-02/Smart%20Home%20Ecosystem%20-%20Product%20Vignette_1.mp4"
          type="video/mp4"
        />
      </video>
    </div>

    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-25" />

    <div className="position-absolute top-50 start-50 translate-middle text-center text-white px-3">
      <div className="mb-3 text-uppercase small fw-semibold">Watch Now</div>
      <h1 className="fw-semibold display-6 display-md-4">
        Welcome to the future of smart home living
      </h1>

      <button
        type="button"
        className="btn btn-light rounded-circle d-inline-flex align-items-center justify-content-center mt-4 p-3" style={{width:70,height:70}}
      >
        <i className="ri-play-fill fs-3" />
      </button>
    </div>
  </div>
</div>


 <section className="position-relative text-white  m-0 pt-4 pb-4"   >
 
 
  <div className="container position-relative py-5"  >
    <div className="row justify-content-between  align-items-center h-100">
      <div className="col-md-6">
        <div className="myheading mb-4  ">
        <h2 className='text-dark'>About <span className="text-Gradient">  Altima Global </span></h2>
        </div>
        <p className="fs-5 mb-4 text-dark ">
          We know that AV and home automation systems are “lifestyle” items that
          should be simple and reliable to operate every time. Today’s
          constantly changing technologies make it harder and harder to operate
          even a basic home theater in a box system. Let AV Automation design a
          system specifically tailored for you and your family. Our AV system
          design and installation experts can make sure that you get all of the
          functions you want in an easy-to-understand and operate system.
        </p>
        
        
      <a href='#' className="hologram-btn">
 <span>  CONTACT US TODAY </span>  <i className="ri-arrow-right-up-line fs-4 fw-light"/>
</a>

      </div>
      <div className="col-md-4">
        <img src="/assets/img/about-img.webp" className='w-100 rounded-4' />
      </div>
    </div>
  </div>
</section>


<div className="multicolumn multicolumn-page pt-50 pb-50 bg-white ">
  <div className="container py-4">

    <div className="multicolumn-inner">
      <div className='myheading'>

 
      <motion.h2   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0 }}
     className=' mb-4 pb-4 '> Why <span className="text-Gradient"> Choose Us </span></motion.h2>
          </div>

      <div  className="row product-grid mt-4">
        <motion.div
          className="col-xl-4 col-md-6 col-12  "
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0 }}

        >
          <a
            className="multicolumn-card border bg-white "
            href="#"
            aria-label="View Service Details"
          >
            <motion.div   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
      transition={{ duration: 0.5, delay: 0.1 }}
     className="card-icon">
       <motion.img   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.2 }}
     src="/assets/img/trust.gif" width={40} className="p-0" />
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.3 }}
     className="heading text-28 mt-3"> Why Trust ALTIMA </motion.h2>
            <motion.div  initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.4 }} className="text text-16">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua.  

            </motion.div>
            
          </a>
        </motion.div>
       

           <motion.div
          className="col-xl-4 col-md-6 col-12  "
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0 }}

        >
          <a
            className="multicolumn-card border bg-white "
            href="#"
            aria-label="View Service Details"
          >
            <motion.div   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.1 }}
     className="card-icon">
       <motion.img   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.2 }}
     src="/assets/img/helpdesk.gif" width={40} className="p-0" />
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.3 }}
     className="heading text-28 mt-3"> Customer Oriented </motion.h2>
            <motion.div  initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.4 }} className="text text-16">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua.  

            </motion.div>
           
           
          </a>
        </motion.div>
       


           <motion.div
          className="col-xl-4 col-md-6 col-12  "
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0 }}

        >
          <a
            className="multicolumn-card border bg-white "
            href="#"
            aria-label="View Service Details"
          >
            <motion.div   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.1 }}
     className="card-icon">
       <motion.img   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.2 }}
     src="/assets/img/smartphone.gif" width={40} className="p-0" />
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.3 }}
     className="heading text-28 mt-3"> Tech Enabled </motion.h2>
            <motion.div  initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.4 }} className="text text-16">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua.  

            </motion.div>
           
          


          </a>
        </motion.div>
       


      </div>
    </div>

  </div>
</div>


</div>

</div>



   <section className="multicolumn multicolumn-page pt-50 pb-50  bg-white">
  
     <div className="container">


    <h4 class=" h6 mb-2"> Products </h4>
  <h2 class="text-start  mb-50 "> Featured    <span class="text-Gradient"> Products & Solutions </span></h2>
   
 

     {/* Cards Slider */}
<Swiper
  spaceBetween={24}
  slidesPerView={1.1}
  breakpoints={{
    576: { slidesPerView: 1.4 },
    768: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
    1200: { slidesPerView: 3 },
  }}
  className="pt-2"
>
  {FEATURED_PRODUCTS.map((item) => (
    <SwiperSlide key={item.id}>
      <div className="h-100">
        <div
          className="w-100"
          style={{
            borderRadius: "24px",
            overflow: "hidden",
            backgroundColor: "#f4f4f4",
            boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
          }}
        >
          {/* Top image area with overlay button */}
          <div
            className="position-relative"
            style={{
              borderRadius: "24px 24px 0 0",
              overflow: "hidden",
            }}
          >
            <img
              src={item.image}
              alt={item.title}
              className="img-fluid w-100"
              style={{ objectFit: "cover", height: "260px" }}
            />

            {/* Overlay bottom bar (like screenshot) */}
            <div
              className="position-absolute start-0 end-0 d-flex align-items-center justify-content-between px-3 pb-3"
              style={{
                bottom: 0,
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.55) 100%)",
              }}
            >
              <button
                type="button"
                className="btn border-0 px-3 py-2"
                style={{
                  borderRadius: "999px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
              >
                Explore solution
              </button>

              <button
                type="button"
                className="border-0 d-flex align-items-center justify-content-center"
                style={{
                  width: "34px",
                  height: "34px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.95)",
                }}
              >
                <span style={{ fontSize: "18px" }}>➜</span>
              </button>
            </div>
          </div>

          {/* Bottom info strip */}
          <div
            className="pt-3 pb-3 px-3 px-md-4 bg-white"
            style={{
              borderRadius: "0 0 24px 24px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div>
                <h5
                  className="mb-0 fw-bold"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  {item.title}
                </h5>
                <small style={{ color: "#8a8a8a" }}>{item.category}</small>
              </div>

              {/* Right small label like “60ML / 100ML” – here use “Key Brands” */}
              <div className="text-end">
                <small
                  style={{
                    fontSize: "11px",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: "#888",
                  }}
                >
                  Key Brands
                </small>
              </div>
            </div>

            <p
              className="mb-0 mt-2"
              style={{
                fontSize: "13px",
                lineHeight: "1.6",
                color: "#555",
              }}
            >
              {item.description}
            </p>
          </div>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>


      </div>
    </section>

 
 
 <section className="position-relative text-white  m-0 pt-4 pb-4"     >
 
   <div className="container position-relative py-5"  >
    <div className="row justify-content-between  align-items-center h-100">

       <div className="col-md-4">
         <img src="/assets/img/bg-image.webp" className='w-100 rounded-4' />
          </div>

      <div className="col-md-6">
        <div className="myheading mb-4 text-dark ">
        <h2 >WHO IS <span className="text-Gradient">  ALTIMA GLOBAL? </span></h2>
        </div>
        <p className="fs-5 mb-4 text-dark  ">
          We know that AV and home automation systems are “lifestyle” items that
          should be simple and reliable to operate every time. Today’s
          constantly changing technologies make it harder and harder to operate
          even a basic home theater in a box system. Let AV Automation design a
          system specifically tailored for you and your family. Our AV system
          design and installation experts can make sure that you get all of the
          functions you want in an easy-to-understand and operate system.
        </p>
        
        
      <a href='#' className="hologram-btn">
  <span> CONTACT US TODAY </span> <i className="ri-arrow-right-up-line fs-4 fw-light"/>
</a>

      </div>

     

    </div>
  </div>
</section>

 
<section className='multicolumn bg-white pt-50 pb-50 multicolumn-page '>
  <div className='container'>
    <div className='row align-items-center col-md-10 mx-auto'>
      <div className='col-md-5'>
<motion.img initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true, amount: 0.3 }}     
    transition={{ duration: 0.5, delay: 0.1 }}
     src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/mobile_app_image.webp" className='w-100' />
      </div>

      <div className='col-md-7'>
        <div className='myheading'> 
<motion.h3 
initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}     
    transition={{ duration: 0.5, delay: 0.2 }}
    className='mb-2'>
  Seamless Compatibility with <span className="text-Gradient"> Android & iOS </span>
</motion.h3>
    </div>
    
<motion.p 
initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}     
    transition={{ duration: 0.5, delay: 0.1 }} >
  Elevate your lifestyle with Auslese Automation—where innovation meets convenience. Our smart home solutions enhance security, energy efficiency, and comfort, giving you seamless control.
</motion.p>
<motion.div 
initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}     
    transition={{ duration: 0.5, delay: 0.2 }} 
    className='d-flex gap-2 my-2'>
  <img src='https://cdn.shopify.com/s/files/1/0925/9247/2384/files/google_lay.png' style={{width:150}}/>
 <img src='https://cdn.shopify.com/s/files/1/0925/9247/2384/files/appstore.png' style={{width:150}} />

</motion.div>

 <motion.div 

 initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}     
    transition={{ duration: 0.5, delay: 0.2 }} 
    
      style={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: "100%",
         padding: "10px 0",
      }}
    >
      <motion.div
      className='android-ios'
        style={{
          display: "inline-block",
          whiteSpace: "nowrap",
        }}
        animate={{ x: ["0%", "-100%"] }} // slide from right to left
        transition={{
          ease: "linear",
          duration: 10, // speed (lower = faster)
          repeat: Infinity,
        }}
        
      >
          <span style={{ marginRight: "50px", display: "inline-block" }} > 
	<img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_1.png" alt="Icon 1"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} ><img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_2.png" alt="Icon 2"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_3.png" alt="Icon 3"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_4.png" alt="Icon 4"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_5.png" alt="Icon 5"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_6.png" alt="Icon 6"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_7.png" alt="Icon 7"style={{width:135}}  /></span>
                     <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_1.png" alt="Icon 1"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_2.png" alt="Icon 2"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_3.png" alt="Icon 3"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_4.png" alt="Icon 4"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_5.png" alt="Icon 5"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_6.png" alt="Icon 6"style={{width:135}}  /></span>
                    <span style={{ marginRight: "50px", display: "inline-block" }} > <img src="https://cdn.shopify.com/s/files/1/0925/9247/2384/files/app_7.png" alt="Icon 7"style={{width:135}}  /></span>
               
      </motion.div>
    </motion.div>

      </div>

    </div>
  </div>

</section>
 

 
  <section className="multicolumn multicolumn-page bg-white"   >
      <div className="py-5">
        <div className="container">
          {/* Heading */}
          <div className="myheading mb-4  ">
            <motion.h3
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5 }}
              className="fw-bold mb-2 text-dark text-uppercase"
            >
              Smart Home <span className="text-Gradient">Automation </span> Facts
            </motion.h3>

            <motion.p
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="text-dark "
            >
              Revolutionizing Modern Living with Technology, Comfort, and Security
            </motion.p>
          </div>

          {/* Facts Row */}
          <div className="row text-center">
            {/* Card 1 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/family-life.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-bold mb-1">
                  <Counter to={5000} suffix="+" />
                </h3>
                <h6 className="fw-medium">Smart Homes Installed</h6>
                <p className="small text-muted mb-0">Across Major Cities in India</p>
              </div>
            </motion.div>

            {/* Card 2 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.25 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/green-energy.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-medium mb-1">
                  <Counter to={99} suffix="%" />
                </h3>
                <h6 className="fw-semibold">Energy Efficiency</h6>
                <p className="small text-muted mb-0">Optimized Power-Saving Automation</p>
              </div>
            </motion.div>

            {/* Card 3 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/phone-signal.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-medium mb-1">
                  <Counter to={50} suffix="+" />
                </h3>
                <h6 className="fw-semibold">Devices Integrated</h6>
                <p className="small text-muted mb-0">Alexa, Google, Apple &amp; More</p>
              </div>
            </motion.div>

            {/* Card 4 (static label) */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.35 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/smart-lock.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-medium mb-1">24x7</h3>
                <h6 className="fw-semibold">Smart Security</h6>
                <p className="small text-muted mb-0">Monitoring &amp; Control Anytime</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  

  <section  className="multicolumn multicolumn-page bg-white pt-4 pb-4" >
    <div className="container py-5">
  {/* Heading + Arrows */}

  
<h4 className=' h6 mb-2'> Blogs </h4>
   <h2 className="text-start  mb-50"> Our <span className='text-Gradient'> Blogs </span></h2>
          
 
  {/* Blog Cards */}
  <div className="row g-4">
   

     {blogData.map((card) => (
        <div className="col-12 col-md-4" key={card.id}>
          <div
            className="card border-0 shadow-sm h-100 rounded-5"
         
          >
            <img
              src={card.image}
              className="card-img-top rounded-5"
              alt={card.title}
              style={{height:250,objectFit:'cover'}}
            />
            <div className="card-body">
              <p className="text-muted small mb-2">{card.date}</p>
              <h5 className="card-title fw-medium ">{card.title}</h5>
            </div>
            <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center pb-3 bg-transparent">
              <small className="text-muted">By {card.author}</small>
              <a href={card.link} className="text-decoration-none fw-semibold small text-dark">
                Continue Reading  <i className="ri-arrow-right-up-line"/>
              </a>
            </div>
          </div>
        </div>
      ))}

  </div>
</div>

  </section>





  <section  className="multicolumn multicolumn-page  pt-4 pb-4" > 
 <div className="container py-5">
  <h4 className='text-dark h6 mb-2'> TESTIMONIALS </h4>
          <h2 className="text-start text-dark  mb-50 ">What Our <span className='text-Gradient'> Customers Say </span></h2>
          <div className="row">
            <Swiper
              breakpoints={{
                300: {
                  slidesPerView: 1,
                  spaceBetween: 10, // Set the gap between slides for window width <= 400px
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 768px
                },
                992: {
                  slidesPerView: 2,
                  spaceBetween: 25, // Set the gap between slides for window width <= 992px
                },
                1200: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 1200px
                },
              }}
              pagination={true}

              modules={[Pagination, Navigation]}
              className="swiper-wrapper"
            >
              {testimonialDate.length === 0 ?
                <>
 
                </> : testimonialDate.map((item) => (
                  <SwiperSlide key={item}>
                  
                  <div className="w-100 p-2">
  <div
    className="p-4 mb-4 shadow bg-white border"
    style={{
       borderRadius: "18px",
      border: "1px solid rgba(255,255,255,0.05)",
     }}
  >
    {/* Stars */}
    <div className="d-flex mb-3">
      <span className="feather icon-star active-star text-warning"></span>
      <span className="feather icon-star active-star text-warning"></span>
      <span className="feather icon-star active-star text-warning"></span>
      <span className="feather icon-star active-star text-warning"></span>
      <span className="feather icon-star active-star text-warning"></span>
    </div>

    {/* Message */}
    <p className="text-dark mb-4" style={{ lineHeight: "1.6", fontSize: "15px" }}>
      {item.message}
    </p>

    {/* Profile Section */}
    <div className="d-flex align-items-center mt-4">
      <div
        className="rounded-circle d-flex align-items-center justify-content-center"
        style={{
          width: "42px",
          height: "42px",
          backgroundColor: "#060000ff",
          color: "#ffffffff",
          fontWeight: "600",
          fontSize: "18px",
        }}
      >
        {item.name.charAt(0)}
      </div>

      <div className="ms-3">
        <div className="fw-bold text-dark" style={{ fontSize: "16px" }}>
          {item.name}
        </div>
        <div className="text-secondary" style={{ fontSize: "13px" }}>
          {item.designation || "Client"}
        </div>
      </div>
    </div>
  </div>
</div>


                  </SwiperSlide>
                ))}


            </Swiper>
 


          </div>
        </div>
  </section>
   
 <section className="multicolumn multicolumn-page bg-white pt-4 pb-4 mt-50 mb-50 d-none">
  <div className="container">

    {/* Heading */}
    <div className=" mb-4 mb-md-5">
      <div className=' mx-auto'>
     <h4 class=" h6 mb-2"> FAQ </h4>
  <h2 class="text-start  mb-50 "> Frequently Asked  <span class="text-Gradient"> Questions </span></h2>
   
      </div>
 </div>

    {/* FAQ Accordion */}
    <div className="row justify-content-center">
      <div className="col-12">
        <div className="accordion" id="faqAccordion">
          {FAQ_DATA.map((item, index) => {
            const collapseId = `faq-collapse-${item.id}`;
            const headingId = `faq-heading-${item.id}`;
            const isFirst = index === 0;

            return (
              <div
                className="accordion-item mb-3 shadow-none border"
                key={item.id}
                style={{
                  borderRadius: "14px",
                  overflow: "hidden",
                  background: "linear-gradient(180deg, #ffffff, #f6f9fb)",
                  border: "1px solid #e8ecef",
                   transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.06)";
                }}
              >
                <h2 className="accordion-header" id={headingId}>
                  <button
                    className={
                      "accordion-button d-flex align-items-center " +
                      (isFirst ? "" : "collapsed")
                    }
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${collapseId}`}
                    aria-expanded={isFirst ? "true" : "false"}
                    aria-controls={collapseId}
                    style={{
                      background: "transparent",
                      color: "#001c25",
                      fontSize: "16px",
                      fontWeight: 600,
                      boxShadow: "none"
                    }}
                  >
                    {item.question}
                  </button>
                </h2>

                <div
                  id={collapseId}
                  className={
                    "accordion-collapse collapse " + (isFirst ? "show" : "")
                  }
                  aria-labelledby={headingId}
                  data-bs-parent="#faqAccordion"
                >
                  <div
                    className="accordion-body"
                    style={{
                      fontSize: "15px",
                      lineHeight: "1.8",
                      color: "#444"
                    }}
                  >
                    {item.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <p style={{ fontSize: "14px", color: "#666" }}>
            Didn’t find your question?
          </p>
          <a
            href="/contact"
            className="text-decoration-none"
            style={{
              color: "#007a98",
              fontSize: "14px",
              fontWeight: 600
            }}
          >
            Contact our team — we’re here to help →
          </a>
        </div>

      </div>
    </div>

  </div>
</section>


    <section
      className="py-5 py-md-6 bg-white"
     >
      <div className="container">
         
            <h4 className='text-dark h6 mb-2'> Trusted by Leading Global Technology Partners  </h4>

          <h2 className="text-start text-dark  mb-50 "> Partner  <span className='text-Gradient'> Brands </span></h2>
      

        {/* Brand grid */}
        <div className="row g-3 g-md-4 justify-content-center">
          {PARTNER_BRANDS.map((brand) => (
            <div
              key={brand.id}
              className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex"
            >
              <a
                href={brand.link}
                className="w-100 text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <div
                  className="h-100 d-flex align-items-center justify-content-center rounded-4 border bg-white"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
                    border: "1px solid rgba(255,255,255,0.07)",
                    padding: "14px 16px",
                    transition: "all 0.25s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0,0,0,0.45)";
                    e.currentTarget.style.border =
                      "1px solid rgba(141, 228, 255, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.border =
                      "1px solid rgba(255,255,255,0.07)";
                  }}
                >
                  {brand.logo ? (
                    <img
                      src={brand.logo}
                      alt={brand.name}
                      className="img-fluid"
                      style={{ maxHeight: "32px", objectFit: "contain" }}
                    />
                  ) : (
                    <span
                      className="text-white fw-semibold"
                      style={{ fontSize: "14px" }}
                    >
                      {brand.name}
                    </span>
                  )}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>


 
   <section className="multicolumn multicolumn-page bg-white pt-50 pb-50  ">

      <div className="container">

        {/* Heading */}
        <div className=" mb-5">
         
  <h4 className=' h6 mb-2'> Awards </h4>
   <h2 className="text-start  mb-50 "> Awards & <span className='text-Gradient'> Certifications </span></h2>
         
 
        </div>

        {/* Awards Grid */}
        <div className="row g-4 justify-content-center">
          {AWARDS.map((award) => (
            <div key={award.id} className="col-6 col-sm-4 col-md-3 col-lg-3 d-flex">
              <div
                className="w-100 text-center p-3 rounded-4"
                style={{
                  background:
                    "linear-gradient(180deg, #ffffff, #f6f9fb)",
                  border: "1px solid #e8ecef",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 28px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0,0,0,0.06)";
                }}
              >
                <img
                  src={award.image}
                  className="img-fluid mb-3"
                  alt={award.title}
                  style={{ height: "80px", objectFit: "contain" }}
                />

                <p
                  className="mt-2 mb-0"
                  style={{ fontSize: "14px", fontWeight: 600, color: "#222" }}
                >
                  {award.title}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
    

           
            <TestingFooter />
        </>

    );
};

export default TestingHome